
<template>
  <div class="flex items-center justify-center w-screen h-screen">
    <div class="text-center">
      <h1 class="mb-5 text-9xl">404</h1>
      <p>{{ $t('notfoundpage') }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound",
  created() {},
  data() {
    return {};
  },
  props: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>

